// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vwF1Q","socialLinks":"Footer_socialLinks__NJgcj","iconLink":"Footer_iconLink__nN1iJ"};